import { screenshotStep } from '@/src/api/requests/screenshotApi'
import { Flight } from '@/src/types/itinerary'
import html2canvas from 'html2canvas'
import { logError } from '../logError'

export async function takeScreenshot(itineraryId: string, step: string, flights: Flight[]) {
    const element = document.body
    const segments = flights.slice(-1)[0]?.segments || []
    const finalDate = segments.slice(-1)[0]?.arrivalDateTime

    try {
        const canvas = await html2canvas(element, {
            useCORS: true,
            width: document.body.scrollWidth,
            height: document.body.scrollHeight,
            windowHeight: document.body.scrollHeight,
            windowWidth: document.body.scrollWidth,
            x: 0,
            y: window.pageYOffset
        })

        const base64Image = canvas.toDataURL('image/jpeg', 0.1)

        const payload = {
            screenshot: base64Image,
            itinerary_id: itineraryId,
            step,
            ddt: finalDate ? new Date(finalDate).toLocaleDateString('in-US') : ''
        }
        screenshotStep(payload)
    } catch (err) {
        logError('Screenshot failed', err)
    }
}
